import React from 'react'
import {Field, Fields, reduxForm} from 'redux-form'
import ContactPersonInput from "./ContactPersonInput";
import ContactPersonPhoneInput from "./ContactPersonPhoneInput";
import FileUpload from './../files/FileUpload';
import {ContactPersonValidator} from './ContactPersonValidator';
import SubmitButton from "../common/SubmitButton";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import ResetButton from "../common/ResetButton";

let ContactPersonFormRedux = props => {
    const {handleSubmit, handleReset, initialValues, isUpdate, isModal, intl} = props;

    let imageSizeLimit = (MAX_IMAGE_SIZE > 1) ? MAX_IMAGE_SIZE - 1 : 1;
    
    return (
        <form onSubmit={handleSubmit} noValidate={true}>
            <Field
                name="workingTitle"
                className="form-control"
                type="text"
                label={intl.formatMessage(messages.title)}
                component={ContactPersonInput}
            />
            <Field
                name="name"
                className="form-control"
                type="text"
                label={intl.formatMessage(messages.name)}
                component={ContactPersonInput}
            />
            <Field
                name="email"
                className="form-control"
                type="email"
                label={intl.formatMessage(messages.email)}
                component={ContactPersonInput}
            />
            <Field
                name="phone"
                className="form-control"
                type="tel"
                label={intl.formatMessage(messages.phone)}
                component={ContactPersonPhoneInput}
                isModal={isModal}
            />
            <Field
                name="mobilePhone"
                className="form-control"
                type="tel"
                label={intl.formatMessage(messages.mobilePhone)}
                component={ContactPersonPhoneInput}
                isModal={isModal}
                isOptional={true}
            />
            <Field
                name="directPhoneNumber"
                className="form-control"
                type="tel"
                label={intl.formatMessage(messages.directPhoneNumber)}
                component={ContactPersonPhoneInput}
                isModal={isModal}
                isOptional={true}
            />
            <div className="form-group row">
                <div className="col-sm-10 offset-sm-2">
                    <label className="custom-control custom-checkbox">
                        <Field
                            name="showVcard"
                            type="checkbox"
                            component="input"
                            className="custom-control-input"
                        />
                        <span className="custom-control-indicator"> </span>
                        <span className="custom-control-description">{intl.formatMessage(messages.contactPersonShowVCard)}</span>
                    </label>
                </div>
            </div>
            <Field
                name="linkedIn"
                className="form-control"
                type="text"
                label="LinkedIn"
                component={ContactPersonInput}
            />
            <Field
                name="facebook"
                className="form-control"
                type="text"
                label="Facebook"
                component={ContactPersonInput}
            />
            <Field
                name="instagram"
                className="form-control"
                type="text"
                label="Instagram"
                component={ContactPersonInput}
            />
            <Field
                name="twitter"
                className="form-control"
                type="text"
                label="Twitter"
                component={ContactPersonInput}
            />
            <div className="form-group row">
                <label className="col-sm-2 col-form-label">
                    <b>Portrætfoto <span className="text-muted">(valgfri)</span></b>
                    <small className="form-text text-muted">{`Maksimal fil størrelse: ${imageSizeLimit} MB.`}</small>
                </label>
                <div className="col-sm-10">
                <Fields
                    type="file"
                    names={[
                        'images',
                        'defaultImages',
                        'defaultImageIds',
                    ]}
                    component={FileUpload}
                    props={{
                        postUrl: 'api/privateV1/users/validate-images',
                        maxFiles: 1,
                        type: 'image',
                    }}
                />
                </div>
            </div>
            <hr/>
            <div className="form-group row">
                <div className="col-sm-12">
                    <div className="offset-sm-2">
                       <SubmitButton isUpdate={isUpdate}/>
                       <ResetButton onClick={handleReset}/>
                    </div>
                </div>
            </div>
        </form>
    )
};

ContactPersonFormRedux = reduxForm({
    form: 'contactPerson',
    validate: ContactPersonValidator,
    onSubmitFail: afterSubmitFail
})(ContactPersonFormRedux);

export default injectIntl(ContactPersonFormRedux);


// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonFormRedux.jsx